module.exports = __webpack_public_path__ + "fonts/Inter-MediumItalic.565a710.woff2";